// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.draft-card[data-v-4ecedec4] {\n  height: 380px;\n  border: 1px solid #E4E4E4;\n  box-sizing: border-box;\n  border-radius: 2px;\n}\n.draft-action-overlay[data-v-4ecedec4] {\n  background: rgba(108, 108, 108, 0.2);\n}\n.overflow-pixel[data-v-4ecedec4] {\n  width: 0;\n  height: 0;\n  overflow: hidden;\n}\n.paper-draft-card[data-v-4ecedec4] {\n  width: 240px;\n}\n", ""]);
// Exports
module.exports = exports;
